import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidateEmail } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import {
    AddressFieldDisplayModel,
} from "@insite/client-framework/Types/ApiModels";

const isEmpty = (value: string) => value.trim().length <= 0;

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

const validateMultipleEmail=(email : string)=>{
    const emailRegex= /^[;,]*((("[^"\r\n]+")|([a-zA-Z0-9._%+-]+))@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+)([;,]\s*((("[^"\r\n]+")|([a-zA-Z0-9._%+-]+))@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+))*[;,]*$/;
    return emailRegex.test(email);
}

replaceInChain(chain, ValidateEmail, props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { email } = props.parameter.address;
    if (addressFieldDisplayCollection.email?.isVisible && validationRules.email?.isRequired && isEmpty(email)) {
        props.addressErrors.email = getRequiredErrorMessage(addressFieldDisplayCollection.email);
    } else if (!isEmpty(email) && !validateMultipleEmail(email)) {
        props.addressErrors.email = siteMessage("AddressInfo_EmailAddress_Validation");
    }
})